import React from 'react'
import { Container, Grid, Typography } from '@material-ui/core'
import { Divider, Button } from 'antd'
import { PostData } from '../../api/service'
import moment from 'moment'
import { Link } from 'react-router-dom'

export default function HomePageEvents() {

  const [data, setData] = React.useState([])
  const [mainEvent, setMainEvent] = React.useState(null)

  const [isLoaded, setIsLoaded] = React.useState(false)

  function __loadFile() {
    let d = {
      dept_code: 'RANGIA',
      type: 'COLLEGE_EVENT',
      homepage: true
    }

    PostData(`/getnoticesbytypedept`, d)
      .then((resp) => {

        setData(resp)
        if (resp.length > 0) {
          setMainEvent(resp[0])
        }
        setIsLoaded(true)
      })
  }

  React.useEffect(() => {
    __loadFile()
  }, [])
  return (
    <div style={{ padding: 30, background: "#F4F6F8" }}>
      
      {/* HEADING */}
      <Divider
        orientation="left"
        style={{
          fontWeight: 700,
          fontSize: 20,
          borderColor: "#D6DBDF",
          color: "#1E3760",
        }}
      >
        NEWS & EVENTS
      </Divider>
  
      <Grid container spacing={3}>
  
        {/* LEFT MAIN EVENT */}
        <Grid item xs={12} md={4}>
          {isLoaded && mainEvent && (
            <div
              style={{
                background: "#fff",
                borderRadius: 10,
                padding: 15,
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                cursor: "pointer",
              }}
            >
              <img
                src={
                  Array.isArray(mainEvent.featured_photo) &&
                  mainEvent.featured_photo.length > 0
                    ? mainEvent.featured_photo[0].url
                    : "/images/prag-small-overview.jpg"
                }
                style={{
                  width: "100%",
                  height: 200,
                  objectFit: "cover",
                  borderRadius: 8,
                }}
              />
  
              <br /><br />
  
              <Typography
                style={{
                  fontSize: 12,
                  color: "#7B7D7D",
                  fontWeight: 600,
                }}
              >
                {moment(mainEvent.date, "DD-MM-YYYY").format("DD MMM YYYY")}
              </Typography>
  
              <Typography
                style={{
                  fontWeight: 700,
                  fontSize: 16,
                  color: "#1E3760",
                  marginTop: 5,
                }}
              >
                {mainEvent.title}
              </Typography>
  
              <div style={{ textAlign: "right", marginTop: 10 }}>
                <Link to={`/singleevent?eventId=${mainEvent.id}`}>
                  <Button
                    style={{
                      background: "#1E3760",
                      color: "#fff",
                      borderRadius: 4,
                    }}
                  >
                    View Event
                  </Button>
                </Link>
              </div>
            </div>
          )}
        </Grid>
  
        {/* RIGHT SIDE EVENTS */}
        <Grid item xs={12} md={8}>
          <Grid container spacing={2}>
          {isLoaded && Array.isArray(data) && data.slice(0, 6).map((el, index) => (
  <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#EAECEE",
        height: 80,
        cursor: "pointer",
      }}
    >
      <div style={{ flexBasis: "30%", height: 80 }}>
        {Array.isArray(el.featured_photo) && el.featured_photo.length > 0 && (
          <img
            src={el.featured_photo[0].url}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        )}

        {(Array.isArray(el.featured_photo) &&
          el.featured_photo.length === 0) ||
        el.featured_photo == null ? (
          <img
            src="/images/prag-small-overview.jpg"
            style={{ width: "100%", height: "100%" }}
          />
        ) : null}
      </div>

      <div style={{ padding: 10, flexBasis: "70%" }}>
        <Typography
          style={{
            fontWeight: 700,
            fontSize: 12,
            color: "#808B96",
          }}
        >
          {moment(el.date, "DD-MM-YYYY").format("DD-MM-YYYY")}
        </Typography>

        <Link to={`/singleevent?eventId=${el.id}`}>
          <Typography
            variant="h6"
            style={{
              fontWeight: 700,
              fontSize: 13,
              overflow: "hidden",
              height: 40,
              textOverflow: "ellipsis",
            }}
          >
            {el.title}
          </Typography>
        </Link>
      </div>
    </div>
  </Grid>
))}
  
            {/* VIEW ALL */}
            <Grid item xs={12} style={{ textAlign: "right" }}>
              <Link to="/events">
                <Button
                  style={{
                    background: "#B22222",
                    color: "#fff",
                    borderRadius: 4,
                  }}
                >
                  View All
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Grid>
  
      </Grid>
    </div>
  );
}
